import React from 'react';

import { CleaningPrestation } from '@front/common/src/types/commons';
import { BasketState } from '@front/common/src/ducks/common/basket';
import colors from '@front/common/src/utils/colors';
import { formatPrice, formatPricePerHour, formatPricePerMonth } from '@front/common/src/utils/formatting';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';
import { Price } from '@front/customer/src/types/prices';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Title from '@front/web-ui/src/components/base-text/variants/title';
import TextButton from '@front/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

type NoMembershipYetProps = {
  reduction: Price;
  getMoreInfoPress: () => void;
  duration: BasketState['duration'];
  cleaningPrestation?: CleaningPrestation;
  isMembershipRequested: boolean;
};

const NoMembershipYet = ({
  reduction,
  getMoreInfoPress,
  duration,
  cleaningPrestation,
  isMembershipRequested,
}: NoMembershipYetProps) => {
  const membershipMonthlyPrice = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()].monthlyPrice;
  const cleaningPrestationTitle = cleaningPrestation?.title.toLowerCase() || '';

  if (!cleaningPrestation?.is_recurrent) {
    const formattedPrice = duration
      ? formatPrice(reduction.price)
      : formatPricePerHour(reduction.hourly_price, { precision: 0 });

    return isMembershipRequested ? (
      <span>
        <Text.SMMedium>{`${t('.reductions.happy')} `}</Text.SMMedium>
        <Text.SMMedium>{`${t('.recurring.no_membership_yet.spot_cleaning.subscribed.text_1')} `}</Text.SMMedium>
        <Title color={colors.pink120}>{`${formattedPrice} `}</Title>
        <Text.SMMedium>{`${t('.recurring.no_membership_yet.spot_cleaning.subscribed.text_2')} `}</Text.SMMedium>
        <TextButton size='sm' onClick={getMoreInfoPress}>
          {t('.more_info_link.the_wecasa_club')}
        </TextButton>
        <Text.SMMedium>
          {t('.recurring.no_membership_yet.spot_cleaning.subscribed.text_3', {
            pricePerMonth: formatPricePerMonth(membershipMonthlyPrice),
          })}
        </Text.SMMedium>
      </span>
    ) : (
      <span>
        <Text.SMMedium>{`${t('.recurring.no_membership_yet.spot_cleaning.not_subscribed.text_1')} `}</Text.SMMedium>
        <Title color={colors.pink120}>{`${formattedPrice} `}</Title>
        <Text.SMMedium>{`${t('.recurring.no_membership_yet.spot_cleaning.not_subscribed.text_2')} `}</Text.SMMedium>
        <TextButton size='sm' onClick={getMoreInfoPress}>
          {t('.more_info_link.the_wecasa_club')}
        </TextButton>
        <Text.SMMedium>
          {t('.recurring.no_membership_yet.spot_cleaning.not_subscribed.text_3', {
            pricePerMonth: formatPricePerMonth(membershipMonthlyPrice),
          })}
        </Text.SMMedium>
      </span>
    );
  }

  return (
    <span>
      <Text.SMMedium>{`${t('.recurring.no_membership_yet.recurring_cleaning.text_1', { prestation: cleaningPrestationTitle })} `}</Text.SMMedium>
      <Text.SMBold
        color={colors.pink120}
      >{`${t('.recurring.no_membership_yet.recurring_cleaning.text_2')} `}</Text.SMBold>
      <Text.SMMedium>{` ${t('.recurring.no_membership_yet.recurring_cleaning.text_3')} `}</Text.SMMedium>
      <TextButton size='sm' onClick={getMoreInfoPress}>
        {t('.more_info_link.wecasa_club')}
      </TextButton>
      <Text.SMMedium>
        {` ${t('.recurring.no_membership_yet.recurring_cleaning.text_4', {
          pricePerMonth: formatPricePerMonth(membershipMonthlyPrice),
        })}`}
      </Text.SMMedium>
    </span>
  );
};

export default NoMembershipYet;
